import React from 'react';
import { useTranslation } from 'react-i18next';
import { SegmentedToggle } from '@/components/segmented-toggle';
const SUPPORTED_LANGUAGES = [
    { value: 'en', label: 'English' },
    { value: 'fr', label: 'Français' },
    { value: 'km', label: 'ភាសាខ្មែរ' },
];
const resolveLanguage = (raw) => {
    if (raw.startsWith('fr'))
        return 'fr';
    if (raw.startsWith('km'))
        return 'km';
    return 'en';
};
export const LanguageSwitcher = () => {
    const { i18n } = useTranslation();
    const current = resolveLanguage(i18n.language);
    const changeLanguage = (next) => {
        if (next === current)
            return;
        localStorage.setItem('adora_lang', next);
        void i18n.changeLanguage(next);
    };
    return (<SegmentedToggle value={current} onValueChange={changeLanguage} items={SUPPORTED_LANGUAGES} layoutId="footer-language-switcher" className="text-xs"/>);
};
